import React, { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";

export default function DeleteAccount() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
  });

   const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

 const handleSubmit = async (e) => {
  e.preventDefault();

  try {
   // alert(JSON.stringify(formData));
    const response = await axios.post(
      "https://inryde.in/dashboard/contact",
      {
        name: formData.name,
        email: formData.email,
        mobile: formData.mobile,
        message: formData.message,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    //alert(JSON.stringify(response));
      alert(response.data.message);
      setFormData({name:"",email:"",mobile:"",message:""})
    

    

  } catch (error) {
    console.error(error);
    alert("Server error");
  }
};


  const colors = {
    primaryRed: "#E63946",
    secondaryYellow: "#FFC300",
    backgroundLight: "#F8F9FA",
    textPrimary: "#1C1C1C",
    textSecondary: "#6C757D",
    white: "#FFFFFF",
    gradient: "linear-gradient(90deg, #E63946, #FFC300)",
  };

  const fonts = {
    heading: "'Poppins', sans-serif",
    body: "'Inter', sans-serif",
  };

  return (
    <section
      style={{
        minHeight: "100vh",
        padding: "80px 20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: fonts.body,
        background: colors.backgroundLight,
        position: "relative",
        overflow: "hidden",
      }}
    >

      {/* glowing circles */}
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 0.3 }}
        transition={{ duration: 1.5 }}
        style={{
          position: "absolute",
          width: "300px",
          height: "300px",
          background: colors.gradient,
          borderRadius: "50%",
          top: "-100px",
          left: "-100px",
          filter: "blur(140px)",
          zIndex: 0,
        }}
      />

      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 0.3 }}
        transition={{ duration: 1.5, delay: 0.3 }}
        style={{
          position: "absolute",
          width: "300px",
          height: "300px",
          background: colors.gradient,
          borderRadius: "50%",
          bottom: "-100px",
          right: "-100px",
          filter: "blur(140px)",
          zIndex: 0,
        }}
      />

      {/* Heading */}
      <motion.h2
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        style={{
          fontFamily: fonts.heading,
          fontSize: "clamp(34px, 6vw, 50px)",
          marginBottom: "10px",
          background: colors.gradient,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          textAlign: "center",
          letterSpacing: "1px",
          zIndex: 2,
        }}
      >
        DELETE ACCOUNT
      </motion.h2>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.8 }}
        style={{
          color: colors.textSecondary,
          marginBottom: "50px",
          textAlign: "center",
          fontSize: "17px",
          maxWidth: "650px",
          zIndex: 2,
          lineHeight: "1.6",
        }}
      >
        This action will permanently delete your account and all related data. This cannot be undone. Please ensure you have downloaded any important data, reviewed our Privacy Policy and Terms of Service, and contacted support if you have questions.
      </motion.p>

      {/* FORM */}
      <motion.form
        onSubmit={handleSubmit}
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8 }}
        style={{
          width: "100%",
          maxWidth: "650px",
          background: colors.white,
          padding: "45px 35px",
          borderRadius: "20px",
          boxShadow: "0 10px 35px rgba(0,0,0,0.12)",
          display: "flex",
          flexDirection: "column",
          gap: "22px",
          position: "relative",
          borderTop: `5px solid ${colors.primaryRed}`,
          zIndex: 2,
        }}
      >

        {/* Fields */}
        {["name", "email", "mobile"].map((field, index) => (
          <input
            key={index}
            required
            name={field}
            placeholder={`Enter your ${field}`}
            value={formData[field]}
            onChange={handleChange}
            style={{
              padding: "13px 14px",
              border: "1.8px solid #ddd",
              borderRadius: "10px",
              fontSize: "15px",
            }}
          />
        ))}

        {/* Reason */}
        <textarea
          name="message"
          required
          placeholder="Reason for deleting account…"
          value={formData.message}
          onChange={handleChange}
          style={{
            padding: "13px 14px",
            border: "1.8px solid #ddd",
            borderRadius: "10px",
            fontSize: "15px",
            resize: "none",
            minHeight: "120px",
          }}
        />

        {/* Button */}
        <motion.button
          type="submit"
          whileHover={{ scale: 1.05 }}
          style={{
            background: colors.gradient,
            color: colors.white,
            borderRadius: "50px",
            padding: "14px",
            fontWeight: "600",
            cursor: "pointer",
            border: "none",
          }}
        >
          SUBMIT
        </motion.button>

      </motion.form>
    </section>
  );
}
